export const DEFAULT_TITLE = 'Autodesk Construction Cloud';

export const SCROLL_CONTAINER_ID = 'scroll-to-top'; //taken from project list providers remote

export const EXO_SKELETON_SCOPE_NAME = 'ACCExoSkeleton';
export const IMPORT_REMOTE_RUNTIME_EVENT_NAME = 'IMPORT_REMOTE_LOADED';

export const MFA_BANNER_SESSION_STORAGE_KEY = 'mfa-setup-banner';

// used for e2e tests
export const LOCAL_URL = new URL('https://local.acc-qa.autodesk.com:3000/');
